<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <tracking-progress :transDataSet="transDate"></tracking-progress>
      <div class="join container">
        <div class="notification">
          <span class="imgWrap"><img src="../../assets/images/thanq_logo.png" /></span>
          <p class="nameSpace"><b>{{overlap}}님 환영합니다!</b></p>
          <p>예비 회원가입이 완료되었습니다.</p>
          <p>내원 후 본인확인을 부탁드립니다.</p>
          <p>본인확인 후 본인 예약 및 검사결과 등 앱의 기능을</p>
          <p>사용하실 수 있습니다.</p>
        </div>
      </div>
      <div class="buttonWrap visible">
        <button type="button" @click="nextMain()" class="pointer">회원가입 완료</button>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '../../components/AppHeader'
import AppSidebar from '../../components/AppSidebar'
import TrackingProgress from '../../components/TrackingProgress'
import AddPopup from '@/components/AddPopup'
import { mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        nextLink: '',
        closeType: 'close'
      },
      transDate: {
        headerName: '회원가입',
        progressNum: '100%',
        chapterNum: 3,
        prevUrl: '/',
        keyName: 'userName'
      },
      overlap: '',
      underAgeChecked: false,
      overAgeChecked: false,
      buttonUp: false,
      setCount: false
    }
  },
  created () {
    /* url 직접 접근 막기 */
    console.log('getReferrer: ', this.getReferrer)
    if (this.getReferrer.includes('formDataTemporary') !== true) {
      this.SET_POPUP(true)
      this.popupSet.content = '잘못된 접근입니다.'
      this.popupSet.count = 'another'
      this.popupSet.nextLink = '/'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = '/'
    }
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.fetchData()
  },
  computed: {
    ...mapState([
      'checkPopup'
    ]),
    ...mapGetters([
      'GET_USERNAME'
    ]),
    ...mapGetters('referrer', [
      'getReferrer'
    ])
  },
  components: {
    AppHeader,
    AppSidebar,
    TrackingProgress,
    AddPopup
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    fetchData () {
      this.overlap = sessionStorage.getItem('joinName')
    },
    nextMain () {
      sessionStorage.removeItem('joinName')
      this.$router.push('/login')
    }
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_POPUP(false)
    this.SET_REFERRER('')
  }
}
</script>

<style lang="scss" scoped>
</style>
